// Responsáveis disponíveis para a justificativa no Portal de Justificativas.
// `cod` é o valor persistido em justificativaInfo.responsavel (Request.js);
// `descricao` é o rótulo exibido no dropdown.
const ResponsavelJustificativa = [
    { cod: "amerinode", descricao: "Amerinode" },
    { cod: "ok", descricao: "OK" },
];

export default ResponsavelJustificativa;
